import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import validator from '../common/util/validator';

class TextArea extends PureComponent {
  constructor(props) {
    super(props);

    const { value, validationRules, coachingFormType, noErrorState } = props;

    this.state = {
      value,
      isTouched: false,
      isFocused: false,
      isValid: (coachingFormType === 3 && noErrorState) || validator(validationRules, value),
    };
  }

  /**
   * blurs hidden input and updates state accordingly
   */
  handleBlur = () => {
    this.setState({ isTouched: true, isFocused: false });
  }

  /**
   * focuses hidden input and updates state accordingly
   */
  handleFocus = () => {
    this.setState({ isFocused: true });
  }

  handleChange = (e) => {
    const { target: { value } } = e;
    const { eventHandler, inputKey, validationRules, coachingFormType, noErrorState } = this.props;

    // checks if it is an unrequired field in process flow forms.
    const isValid = (coachingFormType === 3 && noErrorState) || validator(validationRules, value);

    this.setState({ value, isValid });
    eventHandler(value, inputKey, isValid);
  }

  render() {
    const {
      value,
      isValid,
      isFocused,
      isTouched,
    } = this.state;
    const {
      classNames,
      isDisabled,
      errorMessage,
      noErrorState,
      isErrorTriggered,
    } = this.props;

    const isErrorState = (!noErrorState && !isValid && !isFocused && isTouched)
      || (!isValid && isErrorTriggered && !isFocused);

    let inputState = '';
    if (isDisabled) inputState = '--disabled';
    else if (isValid) inputState = '--valid';
    else if (isFocused) inputState = '--focused';
    else if (isErrorState) inputState = '--error';

    return (
      <div className={`text-area${inputState} ${classNames}`}>
        <div className="text-area-holder">{value}</div>
        <textarea
          readOnly={isDisabled}
          value={value}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          className="text-area__input"
          onChange={this.handleChange}
        />
        {isErrorState && (
          <div onClick={this.handleFocus} className="base-select__required text-area__error">
            {errorMessage}
          </div>
        )}
      </div>
    );
  }
}

TextArea.propTypes = {
  coachingFormType: PropTypes.any,
  value: PropTypes.string.isRequired,
  eventHandler: PropTypes.func.isRequired,
  validationRules: PropTypes.object,
  inputKey: PropTypes.any.isRequired,
  classNames: PropTypes.string,
  errorMessage: PropTypes.string,
  noErrorState: PropTypes.bool,
};

TextArea.defaultProps = {
  coachingFormType: '',
  errorMessage: 'This field is required',
  classNames: '',
  validationRules: {},
  noErrorState: false,
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/features/agent-coaching/TextArea.js